
(function() {
    'use strict';

    angular.module('app').filter('arrayToKeywordParamFilter', function() {

        return function (arr, valueKey) {
            if (!arr || arr.length === 0) return null;
            if (!valueKey || valueKey.length === 0) return null;
            var filteredKeywords = '';
            arr.forEach( function (object, key) {
                if (key > 0) {
                    filteredKeywords = filteredKeywords + '+' + object[valueKey];
                }else {
                    filteredKeywords = object[valueKey];
                }
            });

            return filteredKeywords;
        };
    });

}());